import { rpcClient } from "@/api/WebsocketClient"
import SWR, { Call } from "@/api/SWR"
import { reactive } from "@vue/reactivity"
import SortAndFilterUtil from "@/util/SortAndFilterUtil"
import Page from '@/model/Page';
import SignatureConfig from '@/model/settings/SignatureConfig';

export default class GeneratedGlobalSignatureServiceApi {

    cache: Map<string, Call<any>> = new Map<string, Call<any>>()

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.apis.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        this.cache = new Map<string, Call<any>>()
    }

    get connected(): boolean {
        return rpcClient.state.connected
    }

    _getGlobalSignatures(): Promise<SignatureConfig[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getGlobalSignatures', rpcParams, true).then((data: any) => {
            return data && Array.isArray(data) ? data.map(it => Object.assign(new SignatureConfig(), it)) : Promise.reject()
        })
    }

    _setGlobalSignatures(signatureConfigs: SignatureConfig[]): Promise<SignatureConfig[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('setGlobalSignatures', rpcParams, false).then((data: any) => {
            return data && Array.isArray(data) ? data.map(it => Object.assign(new SignatureConfig(), it)) : Promise.reject()
        })
    }


}
